import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LeagueSearchResult, SearchService, TeamSearchResult} from '@core/services/search.service';
import {Sex} from '@shared/models/sex';
import {GoBackValue} from '@shared/components/favourites/search-pages/search-state-selected/search-state-selected.component';
import {LinkService} from '@core/services/link.service';
import {HomeRoutes} from '@app/routes/home.routes';


@Component({
  selector: 'app-favourites-home',
  templateUrl: './favourites-home.component.html',
  styleUrls: ['./favourites-home.component.scss']
})
export class FavouritesHomeComponent implements OnInit {

  @Input() onMobileView: boolean = false;
  @Output() onSelectionChanged = new EventEmitter<boolean>();
  isLoading = false;
  selectedStateId: string = null;
  selectedSex: Sex = null;
  selectedLeagueId: string = null;
  teams: TeamSearchResult[] = [];
  leagues: LeagueSearchResult[] = [];
  private searchTimer: any = null;
  searchString = '';
  showSearchResults = false;
  registerYourClubLink: string;

  constructor( private searchService: SearchService ) { }

  ngOnInit(): void {
    this.registerYourClubLink = LinkService.getHomeLink() + '/' + HomeRoutes.clubRegistration;
  }

  public stateSelected(event: any) {
    this.onSelectionChanged.emit(true);

    this.isLoading = true;
    this.selectedStateId = event;
  }

  public onFinishedLoading(event: any) {
    this.isLoading = false;
  }

  public onSexSelected(event: Sex) {
    this.onSelectionChanged.emit(true);

    this.isLoading = true;
    this.selectedSex = event;
  }

  public onLeagueSelected(event: any) {
    this.onSelectionChanged.emit(true);

    this.isLoading = true;
    this.selectedLeagueId = event;
  }

  public onGoBack(event: {where: GoBackValue, id: string, sex: Sex}) {
    this.isLoading = true;

    if (event == null) {
      this.isLoading = false;
      return;
    }

    if (event.where === GoBackValue.ToStart) {
      this.selectedStateId = null;
      this.selectedLeagueId = null;
      this.selectedSex = event.sex;

      this.onSelectionChanged.emit(false);
    } else if (event.where === GoBackValue.ToState) {
      this.selectedLeagueId = null;
      this.selectedSex = event.sex;
      this.selectedStateId = event.id;
    } else if (event.where === GoBackValue.ToSex) {
      this.selectedLeagueId = null;
      this.selectedSex = event.sex;
      this.selectedStateId = event.id;
    }

    this.isLoading = false;
  }


  public async searchStringChanged(event: object[]) {
    const searchStringIsDirty = this.searchString !== event.toString();
    if (this.isLoading && searchStringIsDirty === false) {
      return;
    }
    this.isLoading = true;

    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer);
    }

    if (event.toString().length < 3) {
      this.searchString = event.toString();
      this.leagues = [];
      this.teams = [];
      this.showSearchResults = false;
      this.isLoading = false;
      return;
    }

    this.searchTimer = setTimeout(async () => {
      this.searchString = event.toString();

      this.leagues = [];
      this.teams = [];

      const results = await this.searchService.searchTeamsAndLeagues(this.searchString);
      this.teams = results.teams.filter(entry => entry.link != null);
      this.leagues = results.leagues.filter(entry => entry.link != null);

      this.isLoading = false;
      this.showSearchResults = true;
    }, 500);
  }
}
